import { ShieldAlert, Calculator, ReceiptText, Zap, ArrowLeftRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PROBLEMS } from "./data";

const ICONS = { shield: ShieldAlert, calculator: Calculator, receipt: ReceiptText, zap: Zap, switch: ArrowLeftRight };

export const Problem = () => (
    <section id="masalah" className="bg-[#F8F6F1] py-20 lg:py-28" data-testid="problem-section">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
            <Reveal className="max-w-3xl">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#123E65]">Kenali Masalahnya</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-[#1C2533] sm:text-4xl" data-testid="problem-heading">
                    Sudah Siap Beli Rumah, Tapi Sudah Benar-Benar{" "}
                    <span className="font-accent italic text-[#123E65]">Paham KPR?</span>
                </h2>
                <p className="mt-5 text-base leading-relaxed text-[#1C2533]/75 sm:text-lg">
                    Banyak orang fokus pada harga rumah dan besarnya cicilan, tetapi lupa memperhitungkan biaya tambahan, perubahan bunga, hingga konsekuensi dari keputusan pembiayaan jangka panjang.
                </p>
            </Reveal>
            <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="problem-cards">
                {PROBLEMS.map((p, i) => {
                    const Icon = ICONS[p.icon];
                    return (
                        <Reveal key={p.title} delay={i * 0.08}>
                            <div className="group h-full rounded-2xl border border-[#071B37]/8 bg-white p-7 shadow-[0_8px_32px_rgba(7,27,55,0.06)] transition-all duration-300 hover:-translate-y-2 hover:border-[#DDB56C]/50 hover:shadow-[0_16px_40px_rgba(7,27,55,0.12)]" data-testid={`problem-card-${i + 1}`}>
                                <div className="mb-5 inline-flex rounded-xl bg-[#071B37]/5 p-3 transition-colors duration-300 group-hover:bg-[#DDB56C]/15">
                                    <Icon className="h-6 w-6 text-[#123E65]" strokeWidth={1.5} />
                                </div>
                                <h3 className="text-lg font-bold text-[#1C2533]">{p.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-[#1C2533]/70">{p.desc}</p>
                            </div>
                        </Reveal>
                    );
                })}
                <Reveal delay={0.4}>
                    <div className="flex h-full items-center rounded-2xl bg-[#071B37] p-7 shadow-[0_8px_32px_rgba(7,27,55,0.25)]">
                        <p className="text-base font-medium leading-relaxed text-white/90" data-testid="problem-closing">
                            <span className="font-accent italic text-[#DDB56C]">“</span>
                            Karena KPR bukan hanya soal bagaimana membeli rumah, tetapi juga bagaimana mengelola keputusan finansialmu untuk tahun-tahun mendatang.
                            <span className="font-accent italic text-[#DDB56C]">”</span>
                        </p>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
